import { render, staticRenderFns } from "./PublishVideo.vue?vue&type=template&id=83d3927c&scoped=true"
import script from "./PublishVideo.vue?vue&type=script&lang=js"
export * from "./PublishVideo.vue?vue&type=script&lang=js"
import style0 from "./PublishVideo.vue?vue&type=style&index=0&id=83d3927c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83d3927c",
  null
  
)

export default component.exports